export var ACTION;
(function (ACTION) {
    ACTION["TEST_ACTION"] = "TEST_ACTION";
    ACTION["NAV_TO_BANK_ADD"] = "NAV_TO_BANK_ADD";
    ACTION["GO_BACK"] = "GO_BACK";
    ACTION["NEED_HELP"] = "NEED_HELP";
    ACTION["TOGGLE_CTA"] = "TOGGLE_CTA";
    ACTION["NAVIGATION_NEXT"] = "NAVIGATION_NEXT";
    ACTION["T_AND_C_CHECK_1"] = "T_AND_C_CHECK_1";
    ACTION["T_AND_C_CHECK_2"] = "T_AND_C_CHECK_2";
    ACTION["UPDATE_KYC"] = "UPDATE_KYC";
    ACTION["ON_LOAD"] = "ON_LOAD";
})(ACTION || (ACTION = {}));
